export enum HolderType {
  AGENT = "AGENT",
  VEHICLE = "VEHICLE"
}
